var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnUnderline = function SvgIcnUnderline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.5V20.5H6V18.5H20ZM17 11.715C16.9671 12.375 16.7711 13.0165 16.4297 13.5823C16.0883 14.1481 15.6121 14.6205 15.0435 14.9572C14.475 15.294 13.8318 15.4847 13.1716 15.5122C12.5114 15.5397 11.8546 15.4033 11.26 15.115C10.5746 14.8185 9.99341 14.3241 9.59077 13.6952C9.18813 13.0663 8.98242 12.3315 9 11.585V3.505H7V11.715C7.03383 12.6564 7.28885 13.5766 7.74442 14.4012C8.19998 15.2257 8.84329 15.9314 9.62227 16.4611C10.4012 16.9908 11.294 17.3296 12.2283 17.4502C13.1625 17.5707 14.1121 17.4696 15 17.155C16.1811 16.7613 17.2059 16.0012 17.9252 14.985C18.6446 13.9689 19.0211 12.7498 19 11.505V3.505H17V11.715ZM17 3.5H19H17ZM9 3.5H7H9Z",
    fill: "currentcolor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnUnderline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_underline.4fb5aa15.svg";
export { ForwardRef as ReactComponent };